import {DeliveryStepFormFieldType} from 'desktop/pages/checkout/types/checkoutTypes';
import {CountriesType} from 'types/locationType';

/**
 * Perform searching of received state in list of approved state and returns result
 * @param {Array<CountriesType>} countries - Received countries for search
 * @param {string} value - Country ID for searching
 * @returns {DeliveryStepFormFieldType} - Returned address component for specified field
 */
export const getCountriesModifier = (
    countries: Array<CountriesType>,
    value: string,
): DeliveryStepFormFieldType => {
    const isReceivedCountryValid = countries.some(
        (country: CountriesType): boolean => country.value === value,
    );
    return {
        error: false,
        success: true,
        value: isReceivedCountryValid ? value : 'US',
    };
};
